import PropTypes from "prop-types";
import { Autocomplete } from "@mui/material";
import { CustomInputField } from "../../ui";
import { useAuth } from "../../authentication";

export const OutletAutocomplete = ({ onChange, excludeIds = [], ...props }) => {
  const {
    user: { outlets },
  } = useAuth();

  const filteredOutlets = outlets.filter(
    (outlet) => !excludeIds.includes(outlet.id)
  );

  return (
    <Autocomplete
      fullWidth
      // value={outlet}
      options={filteredOutlets}
      // disableClearable={true}
      onChange={(_, value) => onChange(value)}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      renderInput={(params) => (
        <CustomInputField
          {...params}
          InputProps={{
            placeholder: "Cari Outlet",
            ...params.slotProps.input,
          }}
        />
      )}
      {...props}
    />
  );
};

OutletAutocomplete.propTypes = {
  onChange: PropTypes.func,
  excludeIds: PropTypes.array,
};
